import Page from './PinSearchPage';

export default Page;
